import SoftModel from "components/SoftModal";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import Icon from "@mui/material/Icon";


const DeleteModal = ({ openSoftModel, handleCloseModal, deleteConfirmationText, setDeleteConfirmationText, deletesaasmodel, deleteLoading }) => {

    const handleDelete = () => {
        deletesaasmodel();
        handleCloseModal();
    };

    return (
        <SoftModel
            open={openSoftModel}
            onClose={handleCloseModal}
            width="30%"
        >
            <SoftBox>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                    <SoftTypography style={{ fontWeight: 'bold' }}>
                        Delete Plan
                    </SoftTypography>
                    <Icon sx={{ cursor: "pointer" }} onClick={handleCloseModal}>close</Icon>
                </div>

                <SoftTypography style={{ fontSize: '18px' }} color="text" mb={3}>
                    Once deleted your plan can not be restored please type
                    <span style={{ fontWeight: 'bold', color: 'black' }}> Confirm </span>
                    to delete this plan.
                </SoftTypography>

                <SoftBox mb={3}>
                    <SoftInput
                        placeholder="Type Confirm"
                        value={deleteConfirmationText}
                        onChange={(e) => setDeleteConfirmationText(e.target.value)}
                        fullWidth
                    />
                </SoftBox>

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <SoftButton
                        variant="outlined"
                        color="black"
                        onClick={handleCloseModal}
                        disabled={deleteLoading}
                    >
                        Cancel
                    </SoftButton>
                    <SoftButton
                        variant="gradient"
                        color="error"
                        disabled={deleteConfirmationText !== "Confirm" || deleteLoading}
                        onClick={deletesaasmodel}
                    >
                        {deleteLoading ? "Deleting..." : "Delete"}
                    </SoftButton>
                </div>
            </SoftBox>
        </SoftModel>
    )
}
export default DeleteModal;